<template>
  <div>
    <v-app-bar elevation="0" color="white">
      <v-container>
        <v-row>
          <v-app-bar-nav-icon to="/">
            <v-img
              :src="require('../assets/board_logo.png')"
              width="100"
              height="50"
              contain
            ></v-img>
          </v-app-bar-nav-icon>
          <v-spacer></v-spacer>
          <!-- <v-btn depressed color="white" href="/">Home</v-btn> -->
          <!-- v-bind:class="{'small':(this.$vuetify.breakpoint.name === 'sm')}" -->
          <section class="hidden-md-and-up">
            <v-menu bottom left class="hidden-sm-and-up">
              <template v-slot:activator="{ on }">
                <v-btn dark icon v-on="on">
                  <v-icon color="#3c3168">mdi-menu</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item v-for="(item, i) in items" :key="i">
                  <!-- <v-list-item-title>{{ item.title }}</v-list-item-title> -->
                  <v-btn
                    class
                    depressed
                    color="white"
                    :target="item.isBlankTarget ? '_blank' : ''"
                    @click="redirectURL(item)"
                    >{{ item.title }}</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </section>
          <section class="hidden-sm-and-down">
            <span v-for="(item, i) in items" :key="i">
              <v-btn
                :class="{
                  'small-screen': screenWidth,
                }"
                class="nav-btn"
                depressed
                color="white"
                :target="item.isBlankTarget ? '_blank' : ''"
                @click="redirectURL(item)"
                >{{ item.title }}</v-btn
              >
            </span>
          </section>
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon> -->
        </v-row>
      </v-container>
    </v-app-bar>
    <!-- <v-navigation-drawer v-model="drawer" absolute temporary>
      <NavDrawer />
    </v-navigation-drawer> -->
  </div>
</template>
<script>
// import NavDrawer from "./nav-drawer.vue";
export default {
  components: {
    // NavDrawer,
  },
  data() {
    return {
      items: [
        { title: "Verify Tcc", url: "/", isBlankTarget: false },
        {
          title: "Verify Receipt",
          url: "/verify-receipt",
          isBlankTarget: false,
        },
        {
          title: "Verify licence",
          url: "/verify-licence",
          isBlankTarget: false,
        },
        {
          title: "Tax Calculator",
          url: "/assessment",
          isBlankTarget: false,
        },
        // {
        //   title: "File Annual Returns",
        //   url: "https://www.bir.by.gov.ng/filing/#annual_returns",
        //   isBlankTarget: true,
        // },
        {
          title: "Pay Tax",
          url: "https://www.quickteller.com/bayelsa",
          isBlankTarget: true,
        },
        // {
        //   title: "Signup",
        //   url: "",
        //   isBlankTarget: false,
        // },
        // {
        //   title: "Register TIN",
        //   url: "https://tinverification.jtb.gov.ng/Template/TINVerification",
        //   isBlankTarget: true,
        // },
        // {
        //   title: "Get TIN",
        //   url: "https://etax.netlify.app/payments",
        //   isBlankTarget: true,
        // },
      ],
      drawer: null,
    };
  },
  computed: {
    screenWidth() {
      return (
        this.$vuetify.breakpoint.width < 680 &&
        this.$vuetify.breakpoint.width > 600
      );
    },
  },
  methods: {
    redirectURL(item) {
      // eslint-disable-next-line no-console
      console.log("Item:", item);

      if (item.isBlankTarget) {
        window.location.href = item.url;
      } else {
        this.$router.push(item.url);
      }

      //  :target="item.isBlankTarget ? '_blank' : ''"
      //             :to="item.isBlankTarget ? '' : item.url"
      //             :href="item.url"
    },
  },
};
</script>
<style>
.small-screen {
  padding: 5px !important;
}
.nav-btn {
  font-size: clamp(0.6rem, 1vw, 2rem) !important;
}
</style>
